
import {shapeRect} from '@/shapeStorage/shapes/basic/rect.js';
import {shapeCircle} from '@/shapeStorage/shapes/basic/circle.js';
import {shapeRoundedRect} from '@/shapeStorage/shapes/basic/roundedRect.js';
import {shapeRombus} from '@/shapeStorage/shapes/basic/rombus.js';
import {shapeTriangle} from '@/shapeStorage/shapes/basic/triangle.js';
import {shapeRSkewRect} from '@/shapeStorage/shapes/basic/RSkewRect.js';
import {shapeLSkewRect} from '@/shapeStorage/shapes/basic/LSkewRect.js';
import {shapeDownTriangle} from '@/shapeStorage/shapes/basic/downTriangle.js';
import {shapeBubble} from '@/shapeStorage/shapes/basic/bubble.js';
import {shapeArrowRight} from '@/shapeStorage/shapes/basic/arrowRight.js';
import {shapeArrowLeft} from '@/shapeStorage/shapes/basic/arrowLeft.js';
import {shapeArrowLeftRight} from '@/shapeStorage/shapes/basic/arrowLeftRight.js';
import {shapePentagon} from '@/shapeStorage/shapes/basic/pentagon.js';
import {shapeOctagon} from '@/shapeStorage/shapes/basic/octagon.js';
import {shapeHexagon} from '@/shapeStorage/shapes/basic/hexagon.js';
import {shapePredefinedProcess} from '@/shapeStorage/shapes/basic/predefinedProcess.js';
import {shapeTrapezoid} from '@/shapeStorage/shapes/basic/trapezoid.js';
import {shapeCross} from '@/shapeStorage/shapes/basic/cross.js';
import {shapeBraceLeft} from '@/shapeStorage/shapes/basic/braceLeft.js';
import {shapeBraceRight} from '@/shapeStorage/shapes/basic/braceRight.js';

import {shapeDocument} from '@/shapeStorage/shapes/flowchart/document.js';
import {shapeManualInput} from '@/shapeStorage/shapes/flowchart/manualInput.js';
import {shapeDatabase} from '@/shapeStorage/shapes/flowchart/database.js';
import {shapeDirectAccessStorage} from '@/shapeStorage/shapes/flowchart/directAccessStorage.js';
import {shapeInternalStorage} from '@/shapeStorage/shapes/flowchart/internalStorage.js';
import {shapeManualOperation} from '@/shapeStorage/shapes/flowchart/manualOperation.js';
import {shapeDelay} from '@/shapeStorage/shapes/flowchart/delay.js';
import {shapeStoredData} from '@/shapeStorage/shapes/flowchart/storedData.js';
import {shapeMerge} from '@/shapeStorage/shapes/flowchart/merge.js';
import {shapeOr} from '@/shapeStorage/shapes/flowchart/or.js';
import {shapeDisplay} from '@/shapeStorage/shapes/flowchart/display.js';
import {shapeOffPageConnector} from '@/shapeStorage/shapes/flowchart/offPageConnector.js';

export class shapeStorage {

    constructor() {

        this.rect = new shapeRect();
        this.circle = new shapeCircle();
        this.roundedRect = new shapeRoundedRect();
        this.rombus = new shapeRombus();
        this.triangle = new shapeTriangle();
        this.RSkewRect = new shapeRSkewRect();
        this.LSkewRect = new shapeLSkewRect();
        this.downTriangle = new shapeDownTriangle();
        this.bubble = new shapeBubble();
        this.arrowRight = new shapeArrowRight();
        this.arrowLeft = new shapeArrowLeft();
        this.arrowLeftRight = new shapeArrowLeftRight();
        this.pentagon = new shapePentagon();
        this.octagon = new shapeOctagon();
        this.hexagon = new shapeHexagon();
        this.predefinedProcess = new shapePredefinedProcess();
        this.trapezoid = new shapeTrapezoid();
        this.cross = new shapeCross();
        this.braceLeft = new shapeBraceLeft();
        this.braceRight = new shapeBraceRight();
        this.document = new shapeDocument();
        this.manualInput = new shapeManualInput();
        this.database = new shapeDatabase();
        this.directAccessStorage = new shapeDirectAccessStorage();
        this.internalStorage = new shapeInternalStorage();
        this.manualOperation = new shapeManualOperation();
        this.delay = new shapeDelay();
        this.storedData = new shapeStoredData();
        this.merge = new shapeMerge();
        this.or = new shapeOr();
        this.display = new shapeDisplay();
        this.offPageConnector = new shapeOffPageConnector();

    }

    getShape(shape) {
        if (shape == "rect") {
            return this.rect;
        } else if (shape == "circle") {
            return this.circle;
        } else if (shape == "roundedRect") {
            return this.roundedRect;
        } else if (shape == "rombus") {
            return this.rombus;
        } else if (shape == "triangle") {
            return this.triangle;
        } else if (shape == "RSkewRect") {
            return this.RSkewRect;
        } else if (shape == "LSkewRect") {
            return this.LSkewRect;
        } else if (shape == "downTriangle") {
            return this.downTriangle;
        } else if (shape == "bubble") {
            return this.bubble;
        } else if (shape == "arrowRight") {
            return this.arrowRight;
        } else if (shape == "arrowLeft") {
            return this.arrowLeft;
        } else if (shape == "arrowLeftRight") {
            return this.arrowLeftRight;
        } else if (shape == "pentagon") {
            return this.pentagon;
        } else if (shape == "octagon") {
            return this.octagon;
        } else if (shape == "hexagon") {
            return this.hexagon;
        } else if (shape == "predefinedProcess") {
            return this.predefinedProcess;
        } else if (shape == "trapezoid") {
            return this.trapezoid;
        } else if (shape == "cross") {
            return this.cross;
        } else if (shape == "braceLeft") {
            return this.braceLeft;
        } else if (shape == "braceRight") {
            return this.braceRight;
        } else if (shape == "document") {
            return this.document;
        } else if (shape == "manualInput") {
            return this.manualInput;
        } else if (shape == "database") {
            return this.database;
        } else if (shape == "directAccessStorage") {
            return this.directAccessStorage;
        } else if (shape == "internalStorage") {
            return this.internalStorage;
        } else if (shape == "manualOperation") {
            return this.manualOperation;
        } else if (shape == "delay") {
            return this.delay;
        } else if (shape == "storedData") {
            return this.storedData;
        } else if (shape == "merge") {
            return this.merge;
        } else if (shape == "or") {
            return this.or;
        } else if (shape == "display") {
            return this.display;
        } else if (shape == "offPageConnector") {
            return this.offPageConnector;
        }

        return this.rect;
    }

    getAllShapes() {
        var allShapes = ["rect", "circle", "rombus", "triangle", "RSkewRect", "LSkewRect", "downTriangle", "bubble", "arrowRight", "arrowLeft", "arrowLeftRight",
        "pentagon", "octagon", "hexagon", "predefinedProcess", "trapezoid", "cross", "braceLeft", "braceRight", "document", "manualInput", "database",
        "directAccessStorage", "internalStorage", "manualOperation", "delay", "storedData", "merge", "or", "display", "offPageConnector"];

        return allShapes;
    }

    needStroke(mode) {
        var needStroke = ["predefinedProcess", "braceLeft", "braceRight", "database", "directAccessStorage", "internalStorage", "or"];

        for (var i = 0; i < needStroke.length; i++) {
            if (needStroke[i] == mode) {
                return true;
            }
        }

        return false;
    }

    disableFill(mode) {
        var disableFill = ["braceLeft", "braceRight"];

        for (var i = 0; i < disableFill.length; i++) {
            if (disableFill[i] == mode) {
                return true;
            }
        }

        return false;
    }
}
